import { AxiosConfig, ReturnValue, tryCatch } from "front";
import { IContact } from "interfaces/IContact/IContact";

const ROUTE = "/contact-lists/";

const getParticipantsFromGroupAction = async ({ queryKey }: { queryKey: string[] }): Promise<ReturnValue<IContact[]>> => {
  const [_, contactListId, groupId, tenantId, noRequest] = queryKey;
  if (noRequest) return { state: true, variables: queryKey, result: [] };
  const req = AxiosConfig.instance.get(`${ROUTE}${contactListId}/contacts/tenantId/${tenantId}/group/${groupId}`);
  AxiosConfig.updateHeadersToTrack("");
  const res = await req;
  return { state: true, variables: queryKey, result: res.data };
};

const getAllParticipantsForGroupsBySearchAction = async ({ queryKey }: { queryKey: string[] }): Promise<ReturnValue<IContact[]>> => {
  const [_, contactListId, searchPattern, firstLetter, tenantId] = queryKey;
  const query = `searchPattern=${searchPattern}&firstLetter=${firstLetter}`;
  const req = AxiosConfig.instance.get(`${ROUTE}${contactListId}/contacts/tenantId/${tenantId}/groups/search?${query}`);
  AxiosConfig.updateHeadersToTrack("");
  const res = await req;
  return { state: true, variables: queryKey, result: res.data };
};

export const getParticipantFromGroup = tryCatch(getParticipantsFromGroupAction);
export const getAllParticipantsForGroupsBySearch = tryCatch(getAllParticipantsForGroupsBySearchAction);
